export default __webpack_public_path__ + "static/media/touch_ok2.48fa7c9d.mp3";